define('lq/events/actions/executeEidSigner',[
    'jquery', 
    'underscore',
    'lq/events/actions/eventAction', 
    'jquery.jsonp.min'],
function ($, _, EventAction) {
    'use strict';

    var EidServiceUrl = '/eID-IdP/';

    function ExecuteEidSigner(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(ExecuteEidSigner);

    ExecuteEidSigner.typeName = 'ExecuteEidSigner';

    ExecuteEidSigner.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

    ExecuteEidSigner.prototype.createEventActionRequest = function () {
        var self = this;

        return function (continuation) {
            var afterSigning = function (claims) {
                self.executeMappings(claims, self.eventData.eidMappings);

                //var request = {
                //    eventActionType: "EidSigner",
                //    command: self.eventData.command
                //};

                continuation();
            };

            $.ajax({
                url: EidServiceUrl,
                type: 'POST',
                cache: false,
                timeout: 10 * 60 * 1000, // 10 minutes
                dataType: 'json',
                success: function (data) {
                    self.piping.busyIndicator.hide();

                    if (data.error) {
                        alert(data.error);
                        continuation();
                    } else if (!data.success) {
                        alert("eID signing failed.");
                        continuation();
                    }
                    else {
                        afterSigning(data.claims);
                    }
                },
                error: function (error) {
                    busyIndicator.hide();

                    if (error.responseText && error.responseText.length > 0 && error.responseText[0] === '{') {
                        alert(JSON.parse(error.responseText).error);
                    }
                    else {
                        alert("eID signing failed.");
                    }

                    continuation();
                }
            });

            self.piping.busyIndicator.show();
        }
    };

    var valueConvertersByPath = {
    };

    ExecuteEidSigner.prototype.executeMappings = function (data, eidMappings) {
        var self = this;
        _.each(eidMappings, function (mapping) {
            var value = data[mapping.sourcePath];
            if (valueConvertersByPath[mapping.sourcePath])
                value = valueConvertersByPath[mapping.sourcePath](value);
            self.piping.parameters.locals.setValue(mapping.targetParameter, value);
        });
        
    };

    return ExecuteEidSigner;
});
